export default __webpack_public_path__ + "static/media/reactonrails.3b58d2f7.png";